import { useState, useEffect } from 'react';

// Маппинг праздников на фоновые изображения из папки public/backgrounds
const holidayBackgrounds = {
  // Новый год (31 декабря - 2 января)
  newyear: {
    image: '/backgrounds/newyear.jpg',
    name: 'newyear',
    startDate: '12-31',
    endDate: '01-02'
  },
  // 23 февраля - День защитника Отечества
  defender: {
    image: '/backgrounds/defender.jpg',
    name: 'defender',
    startDate: '02-23',
    endDate: '02-23'
  },
  // 8 марта - Международный женский день
  women: {
    image: '/backgrounds/women.jpg',
    name: 'women',
    startDate: '03-08',
    endDate: '03-08'
  },
  // День космонавтики (12 апреля)
  cosmonautics: {
    image: '/backgrounds/cosmonautics.jpg',
    name: 'cosmonautics',
    startDate: '04-12',
    endDate: '04-12'
  },
//   // 1 мая - Праздник весны и труда
//   labor: {
//     image: '/backgrounds/labor.jpg',
//     name: 'labor',
//     startDate: '05-01',
//     endDate: '05-01'
//   },
  // 9 мая - День Победы
  victory: {
    image: '/backgrounds/victory.jpg',
    name: 'victory',
    startDate: '05-09',
    endDate: '05-09'
  },
  // День России (12 июня)
  russia: {
    image: '/backgrounds/russia.jpg',
    name: 'russia',
    startDate: '06-12',
    endDate: '06-12'
  },
  // День Татарстана (30 августа)
  tatarstan: {
    image: '/backgrounds/tatarstan.jpg',
    name: 'tatarstan',
    startDate: '08-30',
    endDate: '08-30'
  }
};

// Функция для форматирования даты в строку MM-DD
const formatDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}-${day}`;
};

// Функция для проверки существования изображения
const checkImageExists = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
};

export const useHolidayBackground = () => {
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [holidayName, setHolidayName] = useState(null);

  useEffect(() => {
    const checkHoliday = async () => {
      const today = new Date();
      const currentDate = formatDate(today);
      
      // Проверяем все праздники
      for (const [key, holiday] of Object.entries(holidayBackgrounds)) {
        let isHoliday = false;
        
        // Проверяем диапазон дат для праздников, которые длятся несколько дней
        if (holiday.endDate && holiday.startDate !== holiday.endDate) {
          const start = holiday.startDate;
          const end = holiday.endDate;
          
          // Для праздников через новый год (например, Новый год)
          if (start > end) {
            if (currentDate >= start || currentDate <= end) {
              isHoliday = true;
            }
          } else {
            if (currentDate >= start && currentDate <= end) {
              isHoliday = true;
            }
          }
        } else {
          // Проверяем точную дату
          if (currentDate === holiday.startDate) {
            isHoliday = true;
          }
        }
        
        if (isHoliday) {
          // Проверяем существование изображения
          const imageExists = await checkImageExists(holiday.image);
          if (imageExists) {
            setBackgroundImage(holiday.image);
            setHolidayName(holiday.name);
            return;
          }
        }
      }
      
      // Если нет праздника, сбрасываем фон
      setBackgroundImage(null);
      setHolidayName(null);
    };
    
    checkHoliday();
    
    // Проверяем каждый день в полночь
    const now = new Date();
    const msUntilMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1) - now;
    
    const timeoutId = setTimeout(() => {
      checkHoliday();
      // Устанавливаем интервал на проверку каждый день
      const intervalId = setInterval(checkHoliday, 24 * 60 * 60 * 1000);
      return () => clearInterval(intervalId);
    }, msUntilMidnight);
    
    return () => clearTimeout(timeoutId);
  }, []);

  return { backgroundImage, holidayName };
};

export default useHolidayBackground;